import { useState, useEffect } from 'react';
import { formsApi } from '../../../apis/formsApi';
import { trackingApi } from '../../../apis/trackingApi';

const useProfileData = () => {
  const [routesList, setRoutesList] = useState([]);
  const [methodsList, setMethodsList] = useState([]);
  const [language, setLanguage] = useState(null);
  const defaultLanguage =  navigator.language.toLowerCase();

  const handleVerifyLogin = (user) => {
    if(!user && !user.locale)
        setLanguage(defaultLanguage);
    let locale = user.locale.toLowerCase();

    if(locale !== "pt-br" && locale !== "en-us"){
      setLanguage(defaultLanguage);
    }else{
      setLanguage(locale);
    }

    setProfileData(prevData => ({ ...prevData,
      userLocale: locale
    }));

    formsApi.getFormList().then(routes => { setRoutesList(routes.data); })
    .catch((error) => { console.error('Erro ao obter dados das rotas:', error); })
 
    trackingApi.getTrackingSendMethods().then(methods => { setMethodsList(methods); })
    .catch((error) => { console.error('Erro ao obter métodos de sistema de tracking:', error); })
  }


  const [profileData, setProfileData] = useState({
    "modelList": [],
    "userLocale": "pt-br",
    "userAccess": [],
    "handleVerifyLogin": handleVerifyLogin  
  });
  
  useEffect(() => {    
    let locale = language;

    if(!language){
      setLanguage(defaultLanguage);
      locale = defaultLanguage;
    }

    setProfileData(prevData => ({ ...prevData,
      userLocale: locale,
      userAccess: routesList,
      modelList: methodsList
    }));
  }, [routesList, methodsList, language, defaultLanguage]);

  return profileData;
};

export default useProfileData;


